<mat-toolbar class="p-0 mat-elevation-z1 shadow-black shadow-sm" role="toolbar" aria-label="Barra de ferramentas principal">

  <!-- Live Region para anúncios de notificações -->
  <div class="sr-only" aria-live="polite" aria-atomic="true" id="toolbar-announcements">
    @if (carregandoNotificacao) {
      Carregando notificações...
    }
  </div>

  <div class="toolbar-element flex w-full h-full flex-row justify-start items-center content-center">

    <div class="flex grow shrink-0 basis-auto flex-row justify-end items-center content-center">

      @if (!hiddenNavbar && !rightNavbar) {
        <button mat-icon-button class="navbar-toggle-button lg:hidden"
          (click)="toggleSidebarOpen('navbar')"
          aria-label="Abrir menu de navegação"
          aria-haspopup="true">
          <mat-icon class="text-secondary" aria-hidden="true">menu</mat-icon>
        </button>
      }

      @if (!hiddenNavbar && !rightNavbar) {
        <div class="toolbar-separator lg:hidden"></div>
      }

      @if (horizontalNavbar) {
        <div class="flex flex-row justify-start items-center content-center">
          <div class="logo ml-2">
            <img class="logo-icon" [src]="_cdkConfigService.logo" alt="Logo do sistema">
          </div>
        </div>
      }
      <cdk-barra-pesquisa class="mr-1 ml-1 pesquisa-rapida" (inputText)="search($event)" *showIfRole="'ROLE_COLABORADOR'"></cdk-barra-pesquisa>
    </div>

    <div class="flex flex-row grow-0 shrink basis-auto justify-start items-center content-center" role="navigation" aria-label="Ações do usuário">
      <div class="avatar-element">
        <button mat-button [matMenuTriggerFor]="userMenu"
          class="user-button"
          aria-label="Menu do usuário"
          aria-haspopup="true">
          <div class="flex flex-row justify-center items-center content-center shrink-1">
            @if (!!userProfile?.imgPerfil?.conteudo === false) {
              <img class="avatar mr-0 sm:mr-2 h-full w-40" src="assets/images/avatars/User.png"
                alt="Avatar do usuário">
            }
            @if (!!userProfile?.imgPerfil?.conteudo === true) {
              <img class="avatar mr-0 sm:mr-2 h-full w-40" [src]="userProfile.imgPerfil.conteudo|safeResourceUrl"
                alt="Foto de perfil do usuário">
            }
            <span class="username mr-3 xs:hidden">{{userProfile?.nome.split(' ')[0]}}</span>
            <span id="dynatrace-username" hidden [attr.data-username]="userProfile?.username">{{userProfile?.username}}</span>
            <mat-icon class="text-base xs:hidden" aria-hidden="true">keyboard_arrow_down</mat-icon>
          </div>
        </button>

        <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

          <button mat-menu-item (click)="goConfiguracoes()" aria-label="Ir para configurações do perfil">
            <mat-icon aria-hidden="true">account_circle</mat-icon>
            <span>Configurações</span>
          </button>

          <button mat-menu-item (click)="goLogout()" aria-label="Sair do sistema">
            <mat-icon aria-hidden="true">exit_to_app</mat-icon>
            <span>Sair</span>
          </button>

        </mat-menu>
      </div>

      @if (!hiddenNavbar && rightNavbar) {
        <div class="toolbar-separator xs:hidden"></div>
      }

      @if(enableChatBot) {
        <div class="toolbar-separator xs:hidden"></div>

      <button mat-icon-button
        class="mr-1 ml-1 quick-panel-toggle-button xs:hidden"
        aria-label="Chat de Ajuda"
        aria-hidden="false"
        id="toolBarChatBotIcon"
        (click)="openChatBotDrawer()">
          <mat-icon aria-hidden="false" matTooltip="Chat de Ajuda" aria-label="Chat de Ajuda">
            auto_awesome
          </mat-icon>
        </button>
      }


      <div class="toolbar-separator xs:hidden"></div>

      <button mat-icon-button
        class="mr-1 ml-1 quick-panel-toggle-button"
        aria-label="Assinadores disponíveis"
        aria-haspopup="true"
        [matMenuTriggerFor]="menuAssinadores">
        <mat-icon aria-hidden="false" matTooltip="Assinadores" [matBadge]="assinadores.length" matBadgePosition="above after"
          [matBadgeHidden]="!assinadores.length"
          [matBadgeDescription]="assinadores.length + ' assinadores disponíveis'"
          [matBadgeColor]="assinadores.length ? 'primary' : 'warn'">
          lock
        </mat-icon>
      </button>
      <mat-menu #menuAssinadores="matMenu" class="menuNotificacao" [overlapTrigger]="false" xPosition="before">
        @if (assinadores.length) {
          <div class="notification-header" role="heading" aria-level="2">
            <div>
              <span class="title">Assinadores</span>
            </div>
          </div>
        }
        @if (assinadores.length) {
          <mat-list role="listbox" aria-label="Lista de assinadores">
            @for (assinador of assinadores; track assinador; let i = $index; let len = $count) {
              <mat-list-item role="option" [attr.aria-selected]="assinador.selecionado">
                <div class="notification-item"
                     (click)="$event.stopPropagation(); setAssinadorSelecionado(assinador)"
                     (keydown.enter)="$event.stopPropagation(); setAssinadorSelecionado(assinador)"
                     tabindex="0"
                     [attr.aria-label]="'Selecionar assinador ' + assinador.hostName">
                  <p style="cursor: pointer; margin: 15px 0 15px 10px; text-align: initial;"
                    [innerHTML]="assinador.hostName">
                  </p>
                  @if (assinador.selecionado) {
                    <div class="actions">
                      <mat-icon class="mat-18" title="Selecionado" aria-label="Selecionado" (click)="$event.stopPropagation()">done</mat-icon>
                    </div>
                  }
                </div>
              </mat-list-item>
              @if (i !== len-1) {
                <mat-divider></mat-divider>
              }
            }
          </mat-list>
        } @else {
          <p class="textoMenu" role="status" aria-live="polite">Não há assinadores</p>
        }
      </mat-menu>

      <div class="toolbar-separator xs:hidden"></div>

      <button mat-icon-button
        class="mr-1 ml-1 quick-panel-toggle-button"
        aria-label="Notificações"
        aria-haspopup="true"
        [matMenuTriggerFor]="menuNoticacoes"
        #menuNoticacoesTrigger="matMenuTrigger"
        (menuOpened)="focusNotificationMenu()"
        (click)="loadNotificacoes()">
        @if (carregandoNotificacao) {
          <mat-icon aria-hidden="true">
            <mat-spinner color="primary" diameter="20"></mat-spinner>
          </mat-icon>
        }
        @if (!carregandoNotificacao) {
          <mat-icon aria-hidden="false" matTooltip="Notificações" [matBadge]="notificacoesCount" matBadgePosition="above after"
            [matBadgeHidden]="!notificacoesCount"
            [matBadgeDescription]="notificacoesCount + ' notificações não lidas'"
            [matBadgeColor]="notificacoesCount ? 'warn' : 'primary'"
            (click)="reload()">
            notifications
          </mat-icon>
        }
      </button>
      <mat-menu #menuNoticacoes="matMenu" class="menuNotificacao" [overlapTrigger]="false" xPosition="before">
        <div class="notification-menu-content"
             cdkTrapFocus
             [cdkTrapFocusAutoCapture]="true"
             tabindex="-1"
             aria-labelledby="notificacoes-titulo"
             (keydown.escape)="menuNoticacoesTrigger.closeMenu()"
             (keydown.tab)="$event.stopPropagation()"
             (click)="$event.stopPropagation()">
          <div class="notification-header">
            <div class="header-left">
              <span class="title" id="notificacoes-titulo" role="heading" aria-level="2" tabindex="-1" cdkFocusInitial>Notificações</span>
              @if (notificacoes.length) {
                <span class="notification-badge" [attr.aria-label]="notificacoes.length + ' notificações'">{{ notificacoes.length }}</span>
              }
              @if (checkedNotifications.length) {
                <span class="selected-count" aria-live="polite">{{ checkedNotifications.length }} selecionada(s)</span>
              }
            </div>
            <div class="actions" role="toolbar" aria-label="Ações de notificações">
              @if (notificacoes.length && checkedNotifications.length) {
                <button mat-icon-button type="button" title="Marcar selecionadas como lida"
                        aria-label="Marcar selecionadas como lida"
                        (click)="$event.stopPropagation(); marcarSelecionadosComoLido()">
                  <mat-icon aria-hidden="true">done</mat-icon>
                </button>
                <button mat-icon-button type="button" title="Remover selecionadas"
                        aria-label="Remover selecionadas"
                        (click)="$event.stopPropagation(); removerSelecionados()">
                  <mat-icon aria-hidden="true">delete</mat-icon>
                </button>
              }
              @if (notificacoes.length && !checkedNotifications.length) {
                <button mat-icon-button type="button" title="Marcar todas como lida"
                        aria-label="Marcar todas como lida"
                        (click)="$event.stopPropagation(); marcarTodasComoLida()">
                  <mat-icon aria-hidden="true">done_all</mat-icon>
                </button>
              }
              <button mat-icon-button type="button" title="Histórico de notificações"
                      aria-label="Ver histórico de notificações"
                      (click)="$event.stopPropagation(); menuNoticacoesTrigger.closeMenu(); goNotificacoes()">
                <mat-icon aria-hidden="true">history</mat-icon>
              </button>
              <button mat-icon-button type="button" class="notification-close-button" title="Fechar notificações"
                      aria-label="Fechar notificações"
                      (click)="menuNoticacoesTrigger.closeMenu()">
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            </div>
          </div>

          <div class="notification-toggle gap-2">
            <span class="toggle-label">Receber notificações</span>
            <p-toggleswitch
              [(ngModel)]="receberNotificacoes"
              (onChange)="toggleReceberNotificacoes()">
            </p-toggleswitch>
          </div>

          @if (notificacoes.length) {
            <mat-list role="list" aria-labelledby="notificacoes-titulo">
              @for (notificacao of notificacoes; track notificacao.id; let i = $index; let len = $count) {
                <mat-list-item [class.non-readed]="!notificacao.dataHoraLeitura"
                               role="listitem"
                               [attr.aria-label]="'Notificação: ' + notificacao.conteudo + (notificacao.dataHoraLeitura ? '' : ' - não lida')">
                  @if (getNotificacaoContext(notificacao)?.id) {
                    <div class="notification-item">
                      <mat-checkbox color="primary"
                                    [attr.aria-label]="'Selecionar notificação'"
                                    (change)="checkNotification($event.checked, notificacao)"></mat-checkbox>
                      <div class="data-hora">
                        <div>{{notificacao.criadoEm?.toJSDate() | date: 'dd/MM/yy HH:mm':'-0300'}}</div>
                      </div>
                      <p [innerHTML]="notificacao.conteudo | titleCasePipe" (click)="sendToTarget(notificacao);">
                      </p>
                      <div class="actions" role="toolbar" aria-label="Ações da notificação">
                        <button mat-icon-button type="button" title="Abrir" aria-label="Abrir notificação"
                                (click)="$event.stopPropagation(); sendToTarget(notificacao)">
                          <mat-icon class="mat-18" aria-hidden="true">search</mat-icon>
                        </button>
                        <button mat-icon-button type="button" title="Abrir em outra aba" aria-label="Abrir em outra aba"
                                (click)="$event.stopPropagation(); openNewTab(notificacao)">
                          <mat-icon class="mat-18" aria-hidden="true">open_in_new</mat-icon>
                        </button>
                        @if (getNotificacaoContext(notificacao)?.componente_digital_id || getNotificacaoContext(notificacao)?.download_token) {
                          <button mat-icon-button type="button" title="Download" aria-label="Baixar arquivo"
                                  (click)="$event.stopPropagation(); download(notificacao)">
                            <mat-icon class="mat-18" aria-hidden="true">cloud_download</mat-icon>
                          </button>
                        }
                        @if (!notificacao.dataHoraLeitura) {
                          <button mat-icon-button type="button" title="Marcar como lida" aria-label="Marcar como lida"
                                  (click)="$event.stopPropagation(); toggleLida(notificacao)">
                            <mat-icon class="mat-18" aria-hidden="true">done</mat-icon>
                          </button>
                        }
                      </div>
                    </div>
                  }
                  @if (!getNotificacaoContext(notificacao)?.id) {
                    <div class="notification-item">
                      <mat-checkbox color="primary"
                                    [attr.aria-label]="'Selecionar notificação'"
                                    (change)="checkNotification($event.checked, notificacao)"></mat-checkbox>
                      <div class="data-hora">
                        <div>{{notificacao.criadoEm?.toJSDate() | date: 'dd/MM/yy HH:mm':'-0300'}}</div>
                      </div>
                      <p [innerHTML]="notificacao.conteudo | titleCasePipe">
                      </p>
                      <div class="actions" role="toolbar" aria-label="Ações da notificação">
                        @if (!notificacao.dataHoraLeitura) {
                          <button mat-icon-button type="button" title="Marcar como lida" aria-label="Marcar como lida"
                                  (click)="$event.stopPropagation(); toggleLida(notificacao)">
                            <mat-icon class="mat-18" aria-hidden="true">done</mat-icon>
                          </button>
                        }
                        @if (getNotificacaoContext(notificacao)?.download_token) {
                          <button mat-icon-button type="button" title="Download" aria-label="Baixar arquivo"
                                  (click)="$event.stopPropagation(); download(notificacao)">
                            <mat-icon class="mat-18" aria-hidden="true">cloud_download</mat-icon>
                          </button>
                        }
                        <button mat-icon-button type="button" title="Remover" aria-label="Remover notificação"
                                (click)="$event.stopPropagation(); removerNotificacao(notificacao)">
                          <mat-icon class="mat-18" aria-hidden="true">delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                </mat-list-item>
                @if (i !== len-1 && !notificacao.dataHoraLeitura) {
                  <mat-divider></mat-divider>
                }
              }
            </mat-list>
          } @else {
            @if (carregandoNotificacao) {
              <div class="flex justify-center p-3" role="status" aria-label="Carregando notificações">
                <mat-icon aria-hidden="true">
                  <mat-spinner color="primary" diameter="20"></mat-spinner>
                </mat-icon>
              </div>
            } @else {
              <div class="actions-sem-not" role="status" aria-live="polite">
                <p class="textoMenu">Não há notificações</p>
              </div>
            }
          }
        </div>
      </mat-menu>

      @if (!hiddenNavbar && rightNavbar) {
        <div class="toolbar-separator xs:hidden"></div>
      }

      <div class="toolbar-separator xs:hidden"></div>

      <button mat-icon-button
        id="help"
        class="mr-1 ml-1 quick-panel-toggle-button2 xs:hidden"
        (click)="toggleSidebarOpen('ajudaPanel')"
        aria-label="Abrir painel de ajuda"
        aria-haspopup="true">
        <mat-icon matTooltip="Ajuda" aria-hidden="true">live_help</mat-icon>
      </button>

      <div class="toolbar-separator xs:hidden"></div>

      <button mat-icon-button
        class="mr-1 ml-1 quick-panel-toggle-button2"
        (click)="toggleChatPanel()"
        aria-label="Abrir chat de mensagens"
        aria-haspopup="true"
        *showIfRole="'ROLE_COLABORADOR'">
        @if (carregandoChat) {
          <mat-icon aria-hidden="true">
            <mat-spinner color="primary" diameter="20"></mat-spinner>
          </mat-icon>
        }
        @if (!carregandoChat) {
          <mat-icon matTooltip="Chat" aria-hidden="false"
            [matBadge]="totalChatMensagensNaoLidas" matBadgePosition="above after"
            [matBadgeHidden]="!totalChatMensagensNaoLidas"
            [matBadgeDescription]="totalChatMensagensNaoLidas + ' mensagens não lidas'"
            [matBadgeColor]="totalChatMensagensNaoLidas ? 'warn' : 'primary'">
            chat
          </mat-icon>
        }
      </button>

      @if (!hiddenNavbar && rightNavbar) {
        <div class="toolbar-separator xs:hidden"></div>
      }

      <div class="toolbar-separator xs:hidden"></div>

      @if ((!this._cdkSidebarService.getSidebar('quickPanel').isLockedOpen || this._cdkSidebarService.getSidebar('quickPanel').folded)
        && operacoesProcessando === 0) {
        <button mat-icon-button
          class="mr-1 ml-1 quick-panel-toggle-button3"
          (click)="toggleQuickPanel()"
          aria-label="Ver últimas operações"
          aria-haspopup="true">
          <mat-icon matTooltip="Últimas Operações" aria-hidden="true">format_list_bulleted</mat-icon>
        </button>
      }

      @if ((!this._cdkSidebarService.getSidebar('quickPanel').isLockedOpen || this._cdkSidebarService.getSidebar('quickPanel').folded)
        && operacoesProcessando > 0) {
        <div style="width: 43px !important; max-width: 43px !important; min-width: 43px !important;"
          class="quick-panel-toggle-button3 mat-icon-button flex justify-center items-center content-center"
          matTooltip="Processando {{operacoesPendentes}}/{{operacoesProcessando}} item(s)..."
          role="button"
          tabindex="0"
          [attr.aria-label]="'Processando ' + operacoesPendentes + ' de ' + operacoesProcessando + ' itens. Clique para ver detalhes.'"
          aria-live="polite"
          (keydown.enter)="toggleQuickPanel()"
          (click)="toggleQuickPanel()">
          <mat-spinner class="m-2" diameter="24" aria-hidden="true"></mat-spinner>
        </div>
      }
    </div>

  </div>
  @if (titulo === 'Inicia Tour') {
    <div>
      <shepherd></shepherd>
    </div>
  }
</mat-toolbar>
